import { ApiBase } from '@bymason/api-base';
import { CmsProductDetailsWidget } from './types';
import tempData from './temp-data';

export * from './types';

class ProductDetailsWidgetCmsApi extends ApiBase {
  private static instance: ProductDetailsWidgetCmsApi;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A ProductDetailsWidgetCmsApi instance
   */
  public static getInstance(): ProductDetailsWidgetCmsApi {
    if (!ProductDetailsWidgetCmsApi.instance) {
      ProductDetailsWidgetCmsApi.instance = new ProductDetailsWidgetCmsApi();
    }

    return ProductDetailsWidgetCmsApi.instance;
  }

  /**
   * Gets the CMS content for the product details widget.
   * @param productId id of the spec-sheet's product.
   * @returns an array of DeviceSpec models
   */
  public async getProductDetailsContent(productId: string) {
    //
    // TODO: Setup endpoint calls to get content from Strapi CMS
    //
    const productData = tempData.find((product) => product.productId === productId);
    if (!productData) throw new Error('Product not found in temp data file!');
    const dataResponse = await Promise.resolve<CmsProductDetailsWidget>(productData);

    return dataResponse;
  }
}

export const productDetailsWidgetCmsApi = ProductDetailsWidgetCmsApi.getInstance();
